import { render, staticRenderFns } from "./popoverNum.vue?vue&type=template&id=0f24cc7d&"
import script from "./popoverNum.vue?vue&type=script&lang=js&"
export * from "./popoverNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports